var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDatabaseTables = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 17,
  cy: 8,
  rx: 10,
  ry: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 8 V17 c0 2.209 4.477 4 10 4 s10 -1.791 10 -4 V8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 17 V26 c0 2.209 4.477 4 10 4 s10 -1.791 10 -4 V17"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDatabaseTables);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_database_tables.8145e7b7eb8d0c84cf9f352302e0808b.svg";